export interface IRequestNoteEnvelope {
  requestNotesDto: IRequestNote[];
  requestNoteCount: number;
}

export interface IRequestNote {
  id: string;
  requestId: string;
  noteType: string;
  note: string;
  dateCreated?: Date;
  createdById: string;
  createdByName: string;
}

//interface extention for custom built items like time in a datetime
export interface IRequestNoteFormValues extends Partial<IRequestNote> {
}

//empty form model
export class RequestNoteFormValues implements IRequestNoteFormValues {
  id: string = "";
  requestId: string = "";
  noteType: string = "";
  note: string = "";

  dateCreated?: Date = undefined;
  createdById: string = "";
  createdByName: string = "";

  constructor(requestId?: string) {
    if (requestId) {
      this.requestId = requestId;
    }
    Object.assign(this);
  }
}
